import styled from "styled-components"

export const ImageTextStyles = styled.div`
  width: 100vw;
  // margin: 20px 0;

  .container {
    width: 100%;
    display: flex;
    flex-flow: ${(props) => (props.about ? "row-reverse" : "row")};
    padding: 100px 100px;
    background-color: ${(props) =>
      props.about ? "white" : "rgb(255 246 228)"};
    justify-content: center;

    @media (max-width: 830px) {
      flex-flow: ${(props) => (props.about ? "column" : "column-reverse")};
      margin: 0;
      align-items: center;
      padding: 0px;
    }
  }

  .text {
    width: 100%;
    align-self: center;
    padding: 50px;
    background-color: ${(props) =>
      props.about ? "white" : "rgb(255 246 228)"};
    .title {
      font-size: 50px;
      font-weight: 700;
      color: #fed9ae;
      line-height: 75px;
      font-family: "PlayfairDisplay-BoldItalic";
    }
    .line {
      width: 80px;
      height: 1px;
      background-color: #ff8a80;
      margin: 50px 0;
    }
    .content {
      max-width: 70%;
      margin: 30px auto 0;
      font-size: 20px;
      @media (max-width: 750px) {
        max-width: 100%;
      }
    }
  }

  .image {
    width: 70%;
    @media (max-width: 750px) {
      width: 100%;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`
